import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  TotalMeetingsCost,
  TopTimeConsumingMeetings,
  TimeSpent,
} from "@client.components/Charts";
import TopChartFilters from "@client.components/TopChartFilters";
import { makeFilter } from "@client.components/TopChartFilters/reducer";
import { makeProfile } from "@client.pages/Login/reducer";
import NavigationTabs from "../NavigationTabs";
import {
  exportAsync,
  makeIsExportLoading,
  setDashboardError,
} from "../reducer";
import "../Dashboard.scss";
import "./Own.scss";
import { FilterType } from "@client.components/TopChartFilters/types";

const DashboardOwn = () => {
  const [setTopBarTitle] = useOutletContext();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const filter = useSelector(makeFilter);
  const profile = useSelector(makeProfile);
  const isExportLoading = useSelector(makeIsExportLoading);

  const setPageError = useCallback(
    (err) => {
      dispatch(setDashboardError(err));
    },
    [dispatch]
  );

  useEffect(() => {
    setTopBarTitle(t("components.NavigationBar.dashboard"));

    return () => {
      setPageError(null);
    };
  }, [t, setTopBarTitle, setPageError]);

  // eslint-disable-next-line no-unused-vars
  const { team, ...restFilter } = filter;
  const ownFilter = {
    ...restFilter,
    email: profile.email.toLowerCase(),
  };

  return (
    <div className="dashboard page">
      <NavigationTabs />
      <div className="body">
        <TopChartFilters
          type={FilterType.own}
          isExportLoading={isExportLoading}
          onExport={() => {
            dispatch(
              exportAsync({
                filter: ownFilter,
                language: i18n.language,
                isCostIndexPresentation: profile.isCostIndexPresentation,
              })
            );
          }}
        />
        <div className="dashboard-content">
          <div className="charts own">
            <div className="chart-grid">
              <TotalMeetingsCost
                isOwn={true}
                filter={ownFilter}
                onError={setPageError}
              />
              <TimeSpent filter={ownFilter} onError={setPageError} />
              <TopTimeConsumingMeetings
                filter={ownFilter}
                onError={setPageError}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardOwn;
